export class AdminUrlKeys {
    public static readonly USERS = '2.4';
    public static readonly QUOTE_TABLES = '3.1.2';
    public static readonly CUSTOM_TABLES = "1.9.05";
    public static readonly BULK_IMPORT_EXPORT = "17.1";
    public static readonly QUOTE_FIELDS_AND_CALCULATIONS = "3.11";
    public static readonly ATTRIBUTES = "1.7";
    public static readonly PRICING_PROCEDURES = "5.16";
    public static readonly DISCOUNTS = "5.6";
    public static readonly CUSTOMER_ROLES_MAPPING = "6.2";
    public static readonly GUIDEDSELLING = "1.16.1";
    public static readonly BULK_DELETION = "3.7";
    public static readonly BULK_QUOTE_DELETION = "3.75";
    public static readonly PRICEBOOKS = "5.15";
    public static readonly RESPONSIVE_TEMPLATES = "8.9";
    public static readonly COUNTRIES = "9.2";
    public static readonly SAP_INTEGRATIONS = '16.1';
    public static readonly THIRD_PARTY_INTEGRATIONS = '16.2';
    public static readonly GLOBAL_SCRIPTS = '15.1';
    public static readonly REPORT_MODULE = '9.15';
    public static readonly PRODUCTS = '1.1111';
    public static readonly CATEGORIES = '1.1';
    public static readonly BULK_IMPORT_EXPORT_PRODUCTS = '17.10';
    public static readonly BULK_IMPORT_EXPORT_PRODUCT_TRANSLATIONS = '17.3.1';
    public static readonly DOCUMENT_GENERATION_TEMPLATES_NEW = '3.35';
    public static readonly DOCUMENT_GENERATION_TEMPLATES_OLD = '3.3';
    public static readonly MANAGE_CONTENT_DOCUMENTS = '3.3.1';
    public static readonly ACTIONS = '4.2';
    public static readonly PRODUCT_CUSTOM_FIELDS = '1.1112';
    public static readonly FAVORITES_PERMISSIONS = '1.14';
    public static readonly WORKFLOW = '4.3';
    public static readonly WORKFLOW_PERMISSIONS = '4.41';
}
